/* ===========================================================================
   DOMUS GIULIETTA: VERIFICAÇÃO DE CERTIFICADO (Bloco E, Tarefa 22)
   Carregado com defer por blocks/dg-verificar-certificado.liquid. Sem dependência
   e sem importar módulos do Horizon. O Liquid não lê a query string (E-D8): o
   número é normalizado aqui e cada endereço candidato é testado com GET, um por
   vez, antes de navegar. Nenhum índice de certificados é publicado.
   Evento para o Bloco F (Tarefa 30): 'dg:certificado_verificado' em document,
   detail = { resultado: 'encontrado' | 'nao_encontrado' }.
   =========================================================================== */
(function () {
  if (window.dgCertificado) return;

  /* Handles possíveis para o que foi digitado, na ordem de tentativa:
     1. máscara da Casa: dg2026001, DG 2026 1, DG-2026-001 -> dg-2026-001
     2. o handle que o admin gera a partir do Número: CERT 014/2024 -> cert-014-2024
     3. espaços viram hífen e o resto da pontuação sai: CERT 014/2024 -> cert-0142024
     4. só letras e dígitos: CERT 014/2024 -> cert0142024 */
  function candidatos(bruto) {
    var texto = String(bruto || '').trim();
    var maiusculo = texto.toUpperCase();
    var cru = maiusculo.replace(/[^A-Z0-9]/g, '');
    var lista = [];
    var mascara = cru.match(/^DG(\d{4})(\d{1,4})$/);
    if (mascara) {
      var sequencia = mascara[2];
      while (sequencia.length < 3) sequencia = '0' + sequencia;
      lista.push('dg-' + mascara[1] + '-' + sequencia);
    }
    lista.push(texto.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''));
    lista.push(maiusculo.replace(/\s+/g, '-').replace(/[^A-Z0-9-]/g, '').toLowerCase());
    lista.push(cru.toLowerCase());
    return lista.filter(function (valor, indice) {
      return valor && lista.indexOf(valor) === indice;
    });
  }

  function avisar(resultado) {
    document.dispatchEvent(new CustomEvent('dg:certificado_verificado', { detail: { resultado: resultado } }));
  }

  function limpar(raiz, campo) {
    var erro = raiz.querySelector('[data-dg-verif-erro]');
    var wa = raiz.querySelector('[data-dg-verif-wa]');
    if (erro) erro.hidden = true;
    if (wa) wa.hidden = true;
    campo.removeAttribute('aria-invalid');
    campo.setAttribute('aria-describedby', campo.getAttribute('data-dg-descricao') || '');
  }

  function mostrarErro(raiz, campo, tipo) {
    var erro = raiz.querySelector('[data-dg-verif-erro]');
    var wa = raiz.querySelector('[data-dg-verif-wa]');
    if (!erro) return;
    Array.prototype.forEach.call(erro.querySelectorAll('[data-dg-verif-msg]'), function (parte) {
      parte.hidden = parte.getAttribute('data-dg-verif-msg') !== tipo;
    });
    erro.hidden = false;
    if (wa) wa.hidden = tipo !== 'nao-encontrado';
    campo.setAttribute('aria-invalid', 'true');
    campo.setAttribute('aria-describedby', (erro.id + ' ' + (campo.getAttribute('data-dg-descricao') || '')).trim());
    erro.focus();
    if (tipo === 'nao-encontrado') avisar('nao_encontrado');
  }

  function verificar(raiz, formulario) {
    var campo = formulario.querySelector('input[name="numero"]');
    var botao = formulario.querySelector('[type="submit"]');
    if (!campo) return;
    if (!campo.hasAttribute('data-dg-descricao')) {
      campo.setAttribute('data-dg-descricao', campo.getAttribute('aria-describedby') || '');
    }
    limpar(raiz, campo);
    if (!campo.value.trim()) {
      mostrarErro(raiz, campo, 'vazio');
      return;
    }
    var prefixo = raiz.getAttribute('data-prefixo') || '/pages/certificado/';
    if (prefixo.charAt(prefixo.length - 1) !== '/') prefixo += '/';
    var enderecos = candidatos(campo.value).map(function (handle) {
      return prefixo + encodeURIComponent(handle);
    });
    if (botao) botao.disabled = true;
    var indice = 0;
    (function tentar() {
      if (indice >= enderecos.length) {
        if (botao) botao.disabled = false;
        mostrarErro(raiz, campo, 'nao-encontrado');
        return;
      }
      var endereco = enderecos[indice++];
      fetch(endereco, { method: 'GET', credentials: 'same-origin', redirect: 'follow' })
        .then(function (resposta) {
          if (resposta.ok) {
            avisar('encontrado');
            window.location.assign(endereco);
          } else {
            tentar();
          }
        })
        .catch(function () {
          window.location.assign(endereco);
        });
    })();
  }

  document.addEventListener('submit', function (evento) {
    var formulario = evento.target.closest('[data-dg-verif-form]');
    if (!formulario) return;
    evento.preventDefault();
    var raiz = formulario.closest('[data-dg-verif]');
    if (raiz) verificar(raiz, formulario);
  });

  window.dgCertificado = { candidatos: candidatos };
})();
